import { useEffect } from 'react';
import { useSettings } from '@/lib/settings-context';

export function usePageTitle(pageTitle?: string) {
  const { theme, themeLoaded } = useSettings();

  useEffect(() => {
    // Wait for the real theme to load instead of flashing the 'App' placeholder —
    // index.html's static "Loading..." title covers this window instead.
    if (!themeLoaded) return;

    const baseTitle = theme.seo_title || theme.app_name || 'App';

    if (pageTitle) {
      document.title = `${pageTitle} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
  }, [pageTitle, theme.app_name, theme.seo_title, themeLoaded]);
}
